import React from 'react';
import PropTypes from 'prop-types';

export default function Textarea(props) {
  let { label, value, maxLength='255', ...args } = props;
  return (
    <div className='km__c--textarea-container'>
      {label ? <label>{label}</label> : null}
      <textarea className='km__c--textarea' value={value} {...args} maxLength={255}></textarea>
      {maxLength ? (
        <span>
          {value?.length ?? 0}/{maxLength}
        </span>
      ) : null}
    </div>
  );
}
Textarea.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  maxLength: PropTypes.string,
};
